var _NotifyUserServiceInit_target;
import { __classPrivateFieldGet } from "tslib";
import { writable } from 'svelte/store';
class NotifyUserServiceInit {
    constructor() {
        _NotifyUserServiceInit_target.set(this, writable(null));
    }
    get target() {
        return __classPrivateFieldGet(this, _NotifyUserServiceInit_target, "f");
    }
    setTarget(target) {
        __classPrivateFieldGet(this, _NotifyUserServiceInit_target, "f").set(target);
    }
}
_NotifyUserServiceInit_target = new WeakMap();
export const NotifyUserService = new NotifyUserServiceInit();
